"use strict";

exports.__esModule = true;
exports.default = _default;

var _reactDom = _interopRequireDefault(require("react-dom"));

var _ownerDocument = _interopRequireDefault(require("dom-helpers/ownerDocument"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(componentOrElement) {
  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(componentOrElement));
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-overlays/utils/ownerDocument.js
// module id = 408
// module chunks = 0